import {canReassignTasks} from '../../TaskManagement/taskTimerState';
import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import User from '../../entities/user';
import Matter from '../../entities/matter';
import Deadline from '../../entities/deadline';
import Conflict from '../../entities/conflict';
import Group from '../../entities/group';
import Role from '../../entities/role';
import TemplateTask from '../../entities/templateTask';
import TimeOff from '../../entities/timeOff';
import Task from '../../entities/task';
export function deleteUser(user: User, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = user.id;}
const _work = workingSet();
store.getState().matters.getMappingFor('userId', user.id).filter(matterTemp => matterTemp.status !== 'D').forEach(matterTemp => {
const _matter = ((_work.get('matter:' + matterTemp.id) ?? matterTemp) as Matter).clone();
_matter.status = 'U';
_matter.addedOn = newHRTimestamp();
_matter.addedBy = getCurrentUserId();
_matter.importSource = targetImportSource;
_matter.importId = mergeId;
_matter.assignedTo = _matter.assignedTo?.filter(id => id !== user.id) || [];

_work.set('matter:' + _matter.id, _matter);
store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
});
store.getState().deadlines.getMappingFor('userId', user.id).filter(deadlineTemp => deadlineTemp.status !== 'D').forEach(deadlineTemp => {
const _deadline = ((_work.get('deadline:' + deadlineTemp.id) ?? deadlineTemp) as Deadline).clone();
_deadline.status = 'U';
_deadline.addedOn = newHRTimestamp();
_deadline.addedBy = getCurrentUserId();
_deadline.importSource = targetImportSource;
_deadline.importId = mergeId;
if (_deadline.completedBy === user.id) {
_deadline.completedBy = null;

}
_work.set('deadline:' + _deadline.id, _deadline);
store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
});
store.getState().conflicts.getMappingFor('userIds', user.id).filter(conflictTemp => conflictTemp.status !== 'D').forEach(conflictTemp => {
const _conflict = ((_work.get('conflict:' + conflictTemp.id) ?? conflictTemp) as Conflict).clone();
_conflict.status = 'U';
_conflict.addedOn = newHRTimestamp();
_conflict.addedBy = getCurrentUserId();
_conflict.importSource = targetImportSource;
_conflict.importId = mergeId;
_conflict.userIds = _conflict.userIds?.filter(id => id !== user.id) || [];

_work.set('conflict:' + _conflict.id, _conflict);
store.dispatch(Actions.ConflictActions.saveConflictQueue(_conflict));
});
store.getState().groups.getMappingFor('userIds', user.id).filter(groupTemp => groupTemp.status !== 'D').forEach(groupTemp => {
const _group = ((_work.get('group:' + groupTemp.id) ?? groupTemp) as Group).clone();
_group.status = 'U';
_group.addedOn = newHRTimestamp();
_group.addedBy = getCurrentUserId();
_group.importSource = targetImportSource;
_group.importId = mergeId;
_group.userIds = _group.userIds?.filter(id => id !== user.id) || [];

_work.set('group:' + _group.id, _group);
store.dispatch(Actions.GroupActions.saveGroupQueue(_group));
});
store.getState().roles.getMappingFor('users', user.id).filter(roleTemp => roleTemp.status !== 'D').forEach(roleTemp => {
const _role = ((_work.get('role:' + roleTemp.id) ?? roleTemp) as Role).clone();
_role.status = 'U';
_role.addedOn = newHRTimestamp();
_role.addedBy = getCurrentUserId();
_role.importSource = targetImportSource;
_role.importId = mergeId;
_role.users = _role.users?.filter(id => id !== user.id) || [];

_work.set('role:' + _role.id, _role);
store.dispatch(Actions.RoleActions.saveRoleQueue(_role));
});
store.getState().templateTasks.getMappingFor('favoritedBy', user.id).filter(templateTaskTemp => templateTaskTemp.status !== 'D').forEach(templateTaskTemp => {
const _templateTask = ((_work.get('templateTask:' + templateTaskTemp.id) ?? templateTaskTemp) as TemplateTask).clone();
_templateTask.status = 'U';
_templateTask.addedOn = newHRTimestamp();
_templateTask.addedBy = getCurrentUserId();
_templateTask.importSource = targetImportSource;
_templateTask.importId = mergeId;
_templateTask.favoritedBy = _templateTask.favoritedBy?.filter(id => id !== user.id) || [];

_work.set('templateTask:' + _templateTask.id, _templateTask);
store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
});
store.getState().timeOffs.getMappingFor('approvedBy', user.id).filter(timeOffTemp => timeOffTemp.status !== 'D').forEach(timeOffTemp => {
const _timeOff = ((_work.get('timeOff:' + timeOffTemp.id) ?? timeOffTemp) as TimeOff).clone();
_timeOff.status = 'U';
_timeOff.addedOn = newHRTimestamp();
_timeOff.addedBy = getCurrentUserId();
_timeOff.importSource = targetImportSource;
_timeOff.importId = mergeId;
if (_timeOff.approvedBy === user.id) {
_timeOff.approvedBy = null;

}
_work.set('timeOff:' + _timeOff.id, _timeOff);
store.dispatch(Actions.TimeOffActions.saveTimeOffQueue(_timeOff));
});
findAll<Deadline>('deadlines').filter(deadlineTemp => deadlineTemp.assignedToType === 'U' && deadlineTemp.assignedTo === user.id && deadlineTemp.status !== 'D').forEach(deadlineTemp => {
const _deadline = ((_work.get('deadline:' + deadlineTemp.id) ?? deadlineTemp) as Deadline).clone();

_deadline.status = 'U';
_deadline.addedOn = newHRTimestamp();
_deadline.addedBy = getCurrentUserId();
_deadline.importSource = targetImportSource;
_deadline.importId = mergeId;
_work.set('deadline:' + _deadline.id, _deadline);
store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
});
findAll<Task>('tasks').filter(taskTemp => taskTemp.assignedToType === 'U' && taskTemp.assignedTo === user.id && taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();

_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
findAll<TemplateTask>('templateTasks').filter(templateTaskTemp => templateTaskTemp.assignedToType === 'U' && templateTaskTemp.assignedTo === user.id && templateTaskTemp.status !== 'D').forEach(templateTaskTemp => {
const _templateTask = ((_work.get('templateTask:' + templateTaskTemp.id) ?? templateTaskTemp) as TemplateTask).clone();

_templateTask.status = 'D';
_templateTask.addedOn = newHRTimestamp();
_templateTask.addedBy = getCurrentUserId();
_templateTask.importSource = targetImportSource;
_templateTask.importId = mergeId;
_work.set('templateTask:' + _templateTask.id, _templateTask);
store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
});



user.status = 'D';
user.addedOn = newHRTimestamp();
user.addedBy = getCurrentUserId();
user.importSource = targetImportSource;
user.importId = mergeId;
store.dispatch(Actions.UserActions.removeUserQueue(user));
}
export function replaceUser(user: User, replaceWith: User, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = user.id;}
const _work = workingSet();
store.getState().matters.getMappingFor('userId', user.id).filter(matterTemp => matterTemp.status !== 'D').forEach(matterTemp => {
const _matter = ((_work.get('matter:' + matterTemp.id) ?? matterTemp) as Matter).clone();
_matter.status = 'U';
_matter.addedOn = newHRTimestamp();
_matter.addedBy = getCurrentUserId();
_matter.importSource = targetImportSource;
_matter.importId = mergeId;
_matter.assignedTo = _matter.assignedTo?.map(id => (id === user.id) ? replaceWith.id : id) || [];

_work.set('matter:' + _matter.id, _matter);
store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
});
store.getState().deadlines.getMappingFor('userId', user.id).filter(deadlineTemp => deadlineTemp.status !== 'D').forEach(deadlineTemp => {
const _deadline = ((_work.get('deadline:' + deadlineTemp.id) ?? deadlineTemp) as Deadline).clone();
_deadline.status = 'U';
_deadline.addedOn = newHRTimestamp();
_deadline.addedBy = getCurrentUserId();
_deadline.importSource = targetImportSource;
_deadline.importId = mergeId;
if (_deadline.completedBy === user.id) {
_deadline.completedBy = replaceWith.id;

}
_work.set('deadline:' + _deadline.id, _deadline);
store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
});
store.getState().conflicts.getMappingFor('userIds', user.id).filter(conflictTemp => conflictTemp.status !== 'D').forEach(conflictTemp => {
const _conflict = ((_work.get('conflict:' + conflictTemp.id) ?? conflictTemp) as Conflict).clone();
_conflict.status = 'U';
_conflict.addedOn = newHRTimestamp();
_conflict.addedBy = getCurrentUserId();
_conflict.importSource = targetImportSource;
_conflict.importId = mergeId;
_conflict.userIds = _conflict.userIds?.map(id => (id === user.id) ? replaceWith.id : id) || [];

_work.set('conflict:' + _conflict.id, _conflict);
store.dispatch(Actions.ConflictActions.saveConflictQueue(_conflict));
});
store.getState().groups.getMappingFor('userIds', user.id).filter(groupTemp => groupTemp.status !== 'D').forEach(groupTemp => {
const _group = ((_work.get('group:' + groupTemp.id) ?? groupTemp) as Group).clone();
_group.status = 'U';
_group.addedOn = newHRTimestamp();
_group.addedBy = getCurrentUserId();
_group.importSource = targetImportSource;
_group.importId = mergeId;
_group.userIds = _group.userIds?.map(id => (id === user.id) ? replaceWith.id : id) || [];

_work.set('group:' + _group.id, _group);
store.dispatch(Actions.GroupActions.saveGroupQueue(_group));
});
store.getState().roles.getMappingFor('users', user.id).filter(roleTemp => roleTemp.status !== 'D').forEach(roleTemp => {
const _role = ((_work.get('role:' + roleTemp.id) ?? roleTemp) as Role).clone();
_role.status = 'U';
_role.addedOn = newHRTimestamp();
_role.addedBy = getCurrentUserId();
_role.importSource = targetImportSource;
_role.importId = mergeId;
_role.users = _role.users?.map(id => (id === user.id) ? replaceWith.id : id) || [];

_work.set('role:' + _role.id, _role);
store.dispatch(Actions.RoleActions.saveRoleQueue(_role));
});
store.getState().templateTasks.getMappingFor('favoritedBy', user.id).filter(templateTaskTemp => templateTaskTemp.status !== 'D').forEach(templateTaskTemp => {
const _templateTask = ((_work.get('templateTask:' + templateTaskTemp.id) ?? templateTaskTemp) as TemplateTask).clone();
_templateTask.status = 'U';
_templateTask.addedOn = newHRTimestamp();
_templateTask.addedBy = getCurrentUserId();
_templateTask.importSource = targetImportSource;
_templateTask.importId = mergeId;
_templateTask.favoritedBy = _templateTask.favoritedBy?.map(id => (id === user.id) ? replaceWith.id : id) || [];

_work.set('templateTask:' + _templateTask.id, _templateTask);
store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
});
store.getState().timeOffs.getMappingFor('approvedBy', user.id).filter(timeOffTemp => timeOffTemp.status !== 'D').forEach(timeOffTemp => {
const _timeOff = ((_work.get('timeOff:' + timeOffTemp.id) ?? timeOffTemp) as TimeOff).clone();
_timeOff.status = 'U';
_timeOff.addedOn = newHRTimestamp();
_timeOff.addedBy = getCurrentUserId();
_timeOff.importSource = targetImportSource;
_timeOff.importId = mergeId;
if (_timeOff.approvedBy === user.id) {
_timeOff.approvedBy = replaceWith.id;

}
_work.set('timeOff:' + _timeOff.id, _timeOff);
store.dispatch(Actions.TimeOffActions.saveTimeOffQueue(_timeOff));
});
findAll<Deadline>('deadlines').filter(deadlineTemp => deadlineTemp.assignedToType === 'U' && deadlineTemp.assignedTo === user.id && deadlineTemp.status !== 'D').forEach(deadlineTemp => {
const _deadline = ((_work.get('deadline:' + deadlineTemp.id) ?? deadlineTemp) as Deadline).clone();
_deadline.assignedTo = replaceWith.id;
_deadline.status = 'U';
_deadline.addedOn = newHRTimestamp();
_deadline.addedBy = getCurrentUserId();
_deadline.importSource = targetImportSource;
_deadline.importId = mergeId;
_work.set('deadline:' + _deadline.id, _deadline);
store.dispatch(Actions.DeadlineActions.saveDeadlineQueue(_deadline));
});
findAll<Task>('tasks').filter(taskTemp => taskTemp.assignedToType === 'U' && taskTemp.assignedTo === user.id && taskTemp.status !== 'D').filter(canReassignTasks).forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.assignedTo = replaceWith.id;
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
findAll<TemplateTask>('templateTasks').filter(templateTaskTemp => templateTaskTemp.assignedToType === 'U' && templateTaskTemp.assignedTo === user.id && templateTaskTemp.status !== 'D').forEach(templateTaskTemp => {
const _templateTask = ((_work.get('templateTask:' + templateTaskTemp.id) ?? templateTaskTemp) as TemplateTask).clone();
_templateTask.assignedTo = replaceWith.id;
_templateTask.status = 'U';
_templateTask.addedOn = newHRTimestamp();
_templateTask.addedBy = getCurrentUserId();
_templateTask.importSource = targetImportSource;
_templateTask.importId = mergeId;
_work.set('templateTask:' + _templateTask.id, _templateTask);
store.dispatch(Actions.TemplateTaskActions.saveTemplateTaskQueue(_templateTask));
});
findAll<Matter>('matters').filter(matterTemp => matterTemp.status !== 'D' && matterTemp.hasOwnProperty('hourlyRates')).filter(matterTemp => !!matterTemp.hourlyRates?.some(item => item.id === user.id)).forEach(matterTemp => {
const _matter = ((_work.get('matter:' + matterTemp.id) ?? matterTemp) as Matter).clone();
if (!!_matter.hourlyRates) {_matter.hourlyRates = [..._matter.hourlyRates].map(f => {if (f.id === user.id) {const _f = {...f}; _f.id = replaceWith.id; return _f;} else return f;});} else {_matter.hourlyRates = [];}
_matter.status = 'U';
_matter.addedOn = newHRTimestamp();
_matter.addedBy = getCurrentUserId();
_matter.importSource = targetImportSource;
_matter.importId = mergeId;
_work.set('matter:' + _matter.id, _matter);
store.dispatch(Actions.MatterActions.saveMatterQueue(_matter));
});
findAll<Conflict>('conflicts').filter(conflictTemp => conflictTemp.status !== 'D' && conflictTemp.hasOwnProperty('userSignOffs')).filter(conflictTemp => !!conflictTemp.userSignOffs?.some(item => item.userId === user.id)).forEach(conflictTemp => {
const _conflict = ((_work.get('conflict:' + conflictTemp.id) ?? conflictTemp) as Conflict).clone();
if (!!_conflict.userSignOffs) {_conflict.userSignOffs = [..._conflict.userSignOffs].map(f => {if (f.userId === user.id) {const _f = {...f}; _f.userId = replaceWith.id; return _f;} else return f;});} else {_conflict.userSignOffs = [];}
_conflict.status = 'U';
_conflict.addedOn = newHRTimestamp();
_conflict.addedBy = getCurrentUserId();
_conflict.importSource = targetImportSource;
_conflict.importId = mergeId;
_work.set('conflict:' + _conflict.id, _conflict);
store.dispatch(Actions.ConflictActions.saveConflictQueue(_conflict));
});

return user;
}
export function deleteImpactUser(user: User) {
const impacts: string[] = [];
const state = store.getState();
const matterAssignedToImpact = state.matters.getMappingFor('userId', user.id).filter(matter => matter.status !== 'D');
matterAssignedToImpact.forEach(() => impacts.push('matters'));
const deadlineCompletedByImpact = state.deadlines.getMappingFor('userId', user.id).filter(deadline => deadline.status !== 'D');
deadlineCompletedByImpact.forEach(() => impacts.push('deadlines'));
const conflictUserIdsImpact = state.conflicts.getMappingFor('userIds', user.id).filter(conflict => conflict.status !== 'D');
conflictUserIdsImpact.forEach(() => impacts.push('conflicts'));
const groupUserIdsImpact = state.groups.getMappingFor('userIds', user.id).filter(group => group.status !== 'D');
groupUserIdsImpact.forEach(() => impacts.push('groups'));
const roleUsersImpact = state.roles.getMappingFor('users', user.id).filter(role => role.status !== 'D');
roleUsersImpact.forEach(() => impacts.push('roles'));
const templateTaskFavoritedByImpact = state.templateTasks.getMappingFor('favoritedBy', user.id).filter(templateTask => templateTask.status !== 'D');
templateTaskFavoritedByImpact.forEach(() => impacts.push('templateTasks'));
const timeOffApprovedByImpact = state.timeOffs.getMappingFor('approvedBy', user.id).filter(timeOff => timeOff.status !== 'D');
timeOffApprovedByImpact.forEach(() => impacts.push('timeOffs'));
const deadlineAssignedToTypeImpact = findAll<Deadline>('deadlines').filter(deadline => deadline.assignedToType === 'U' && deadline.assignedTo === user.id && deadline.status !== 'D');
deadlineAssignedToTypeImpact.forEach(() => impacts.push('deadlines'));
const taskAssignedToTypeImpact = findAll<Task>('tasks').filter(task => task.assignedToType === 'U' && task.assignedTo === user.id && task.status !== 'D');
taskAssignedToTypeImpact.forEach(() => impacts.push('tasks'));
const templateTaskAssignedToTypeImpact = findAll<TemplateTask>('templateTasks').filter(templateTask => templateTask.assignedToType === 'U' && templateTask.assignedTo === user.id && templateTask.status !== 'D');
templateTaskAssignedToTypeImpact.forEach(() => impacts.push('templateTasks'));
const matterHourlyRatesImpact = findAll<Matter>('matters').filter(matter => matter.status !== 'D' && matter.hasOwnProperty('hourlyRates')).filter(matter => !!matter.hourlyRates?.some(item => item.id === user.id));
matterHourlyRatesImpact.forEach(() => impacts.push('matters'));
const conflictUserSignOffsImpact = findAll<Conflict>('conflicts').filter(conflict => conflict.status !== 'D' && conflict.hasOwnProperty('userSignOffs')).filter(conflict => !!conflict.userSignOffs?.some(item => item.userId === user.id));
conflictUserSignOffsImpact.forEach(() => impacts.push('conflicts'));

return util.countDistinct(impacts);
}
